/* External */
import { useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

/* Storage */
import { fetchShowById, selectShowById } from '../storage/shows';

/* Utils */
import { PROVIDERS } from '../utils/constants';

export default function useFetchShow(showId, requiredProps = [], sourceProvider = PROVIDERS.VRIO) {
  const dispatchTrigger = useRef(false);
  const dispatch = useDispatch();
  const showSelector = useMemo(() => selectShowById(`${showId}-${sourceProvider}`), [showId, sourceProvider]);
  const show = useSelector(showSelector);

  useEffect(() => {
    dispatchTrigger.current = false;
  }, [showId]);

  useEffect(() => {
    const hasProperties = show && requiredProps.every((prop) => !!show[prop]);
    if ((!show || !hasProperties) && showId && !dispatchTrigger.current) {
      const action = fetchShowById({
        showId,
        sourceProvider,
      });
      dispatch(action);
      dispatchTrigger.current = true;
    }
  }, [dispatch, requiredProps, show, showId, sourceProvider]);

  return show;
}
